<template>
  <div>
    <validation-observer ref="observer" v-slot="{ handleSubmit }">
      <template v-if="errorMessage">
        <v-alert
          type="error"
        >
          {{ errorMessage }}
        </v-alert>
      </template>
      <div class="text-sm-right mb-4 mt-4 group">
        <div v-if="checkAuthorization('kpi_update')" class="group-btn">
          <v-btn
            class="success mx-0 mr-2"
            small
            @click.prevent="handleSubmit(saveKpiDepartments)"
          >
            <v-icon size="18" class="mr-1">mdi-content-save</v-icon> Lưu lại
          </v-btn>
          <v-btn
            class="default mx-0"
            small
            @click="cancelSave"
          >
            <v-icon size="18" class="mr-1">mdi-cancel</v-icon> Dismiss
          </v-btn>
        </div>
      </div>
      <v-simple-table class="table-layout table-custom">
        <template v-slot:default>
          <thead>
            <tr>
              <th
                :rowspan="2"
              >
                STT
              </th>
              <th
                :rowspan="2"
              >
                Nhóm
              </th>
              <th
                :rowspan="2"
              >
                Số nhân viên
              </th>
              <th
                :colspan="8"
              >
                Doanh số
              </th>
            </tr>
            <tr>
              <th>
                Chỉ tiêu doanh thu
              </th>
              <th>
                Doanh thu thực tế
              </th>
              <th>
                Độ quan trọng DT (%)
              </th>
              <th>
                Chỉ tiêu tỉ lệ chốt (%)
              </th>
              <th>
                Tỷ lệ chốt thực tế (%)
              </th>
              <th>
                Độ quan trọng TLC (%)
              </th>
              <th>
                KPI (%)
              </th>
              <th>
                Ghi chú
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(department, index) in departments">
              <tr :key="department.id">
                <td>
                  {{ index + 1 }}
                </td>
                <td>
                  {{ _.get(department, 'name', '') }}
                </td>
                <td>
                  {{ _.get(department, 'totalMember', '') }}
                </td>
                <td :class="getClass(department, 'targetRevenue')">
                  <validation-provider
                    v-slot="{ errors }"
                    class="mb-2"
                    :rules="{ required: true, min_value: 0, max_value: 999999999999999, max: 15 }"
                    name="Chỉ tiêu doanh thu"
                    :vid="`targetRevenue_${department.id}`"
                  >
                    <v-currency-field
                      :error-messages="errors"
                      v-model="department.targetRevenue"
                      :readonly="passed"
                    />
                  </validation-provider>
                </td>
                <td>
                  {{ formatPrice(_.get(department, 'turnOverSuccess', 0)) }}
                </td>
                <td :class="getClass(department, 'importantLevel')">
                  <validation-provider
                    v-slot="{ errors }"
                    class="mb-2"
                    :rules="{required: true, regex: /^[0-9]*$/, min_value: 0, max_value: 100  }"
                    name="Độ quan trọng DT"
                    :vid="`importantLevel_${department.id}`"
                  >
                    <v-text-field
                      v-model="department.importantLevel"
                      :error-messages="errors"
                      color="primary"
                      :readonly="passed"
                      @change="calculateRate('importantLevel', department.importantLevel, index)"
                    />
                  </validation-provider>
                </td>
                <td :class="getClass(department, 'targetRate')">
                  <validation-provider
                    v-slot="{ errors }"
                    class="mb-2"
                    :rules="{required: true, regex: /^[0-9]*$/, min_value: 0, max_value: 100  }"
                    name="Chỉ tiêu tỷ lệ chốt"
                    :vid="`targetRate_${department.id}`"
                  >
                    <v-text-field
                      v-model="department.targetRate"
                      :error-messages="errors"
                      color="primary"
                      :readonly="passed"
                    />
                  </validation-provider>
                </td>
                <td>
                  {{ _.get(department, 'latchRatioSuccess', '') }}
                </td>
                <td :class="getClass(department, 'importantRateLevel')">
                  <validation-provider
                    v-slot="{ errors }"
                    class="mb-2"
                    :rules="{required: true, regex: /^[0-9]*$/, min_value: 0, max_value: 100  }"
                    name="Độ quan trọng TLC"
                    :vid="`importantLevel_${department.id}`"
                  >
                    <v-text-field
                      v-model="department.importantRateLevel"
                      :error-messages="errors"
                      color="primary"
                      :readonly="passed"
                      @change="calculateRate('importantRateLevel', department.importantRateLevel, index)"
                    />
                  </validation-provider>
                </td>
                <td>
                  {{ _.get(department, 'kpi', 0) + '%' }}
                </td>
                <td>
                  <validation-provider
                    v-slot="{ errors }"
                    class="mb-2"
                    rules=""
                    name="Ghi chú"
                  >
                    <v-text-field
                      v-model="department.note"
                      :error-messages="errors"
                      color="primary"
                    />
                  </validation-provider>
                </td>
              </tr>
            </template>
          </tbody>
        </template>
      </v-simple-table>
    </validation-observer>
  </div>
</template>
<script>
  import { formatPrice } from '@/helpers/utils'
  import RepositoryFactory from '../../../repositories/RepositoryFactory'
  const KpiRepository = RepositoryFactory.get('kpi')
  export default {
    props: {
      departments: {
        type: Array,
        default: () => {},
      },
      oldDepartments: {
        type: Array,
        default: () => {},
      },
      activeTab: {
        type: Number,
        default: null,
      },
      passed: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        errorMessage: '',
      }
    },
    created () {
    },
    methods: {
      async cancelSave () {
        this.$set(this, 'departments', _.cloneDeep(this.oldDepartments))
      },
      async saveKpiDepartments () {
        const isValid = await this.$refs.observer.validate();
        if (isValid) {
          const kpiDepartments = this.departments.map(department => ({
            departmentId: department.id,
            targetRevenue: department.targetRevenue,
            importantLevel: department.importantLevel,
            targetRate: department.targetRate,
            importantRateLevel: department.importantRateLevel,
            note: department.note,
          }))
          // do save data
          // const loader = this.$loading.show()
          this.appLoadingData(true)
          const kpiId = this.$route.params.id
          const response = await KpiRepository.saveKpiDetail(kpiId, kpiDepartments)
          // loader.hide()
          this.appLoadingData(false)
          if (response.success) {
            this.$swal({
              title: 'Lưu thành công!',
              confirmButtonText: 'Đồng ý',
            }).then(() => {
              // window.location.href = `/users/kpi/detail/${this.$route.params.id}?activeTab=${this.activeTab}`
              this.$router.push({
                name: 'KPIDetail',
                params: { id : kpiId || 0 },
                query: {activeTab: `${this.activeTab}`}
              })
            })
          } else {
            this.errorMessage = _.get(response, 'message', '')
          }
        }
      },
      getClass(department, fieldName) {
        const oldValue = _.get(this.oldDepartments.find(u => u.id === department.id), fieldName, null);
        if(oldValue && _.get(department, fieldName, null) && parseInt(oldValue, 10) !== parseInt(_.get(department, fieldName, null), 10)) return 'text-updating'
        else if(!oldValue && _.get(department, fieldName, null)) return 'text-updating'
        return ''
      },
      calculateRate(e, value, index) {
        if (value > 100) return
        if(e == 'importantLevel') {
          this.departments[index].importantRateLevel = 100 - value
        } else {
          this.departments[index].importantLevel = 100 - value
        }
      }
    },
  }
</script>
<style scoped lang="scss">
  .table-custom {
    .text-updating{
      background-color: #ECFDF0;
    }
  }
</style>
